export const TimelineLayout = {
  // Default amount of pixels that will be displayed to the left of the first item when the timeline is first rendered or after a reset.
  STARTING_LEFT_OFFSET: 200,

  // Number of pixels to move the timeline by when a free scroll is initiated.
  FREE_SCROLL_STEP: 10,

  // Padding to apply around the left and right boundaries of the timeline.
  LEFT_BOUNDARY_PADDING: 15,

  // Padding to apply around the right boundary of the timeline.
  RIGHT_BOUNDARY_PADDING: 15,

  // Padding to apply around the bottom boundary of the timeline.
  BOTTOM_BOUNDARY_PADDING: 20,

  // Margin value used for the timeline's vertical axis.
  AXIS_MARGIN: 50,

  // Width of the scrubber handle element.
  HANDLE_WIDTH: 20,

  // Height of the scrubber handle element.
  HANDLE_HEIGHT: 40,
}
